const s = {
  name: "PosMobile",
  dimensions: { width: 39, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.2 40" style="enable-background:new 0 0 39.2 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15.5,18.5C14.6,19.4,14,20.6,14,22c0,1.4,0.6,2.6,1.5,3.5L14.1,27c-1.3-1.3-2.1-3-2.1-5c0-1.9,0.8-3.7,2.1-5
			L15.5,18.5z"/>
		<path class="st0" d="M10,22c0-2.5,1-4.7,2.6-6.4l-1.4-1.4C9.2,16.2,8,19,8,22c0,3,1.2,5.8,3.2,7.8l1.4-1.4C11,26.7,10,24.5,10,22z
			"/>
		<path class="st0" d="M30,35v-5.6l8.3-8.3c1.2-1.2,1.2-3.1,0-4.2l-7.2-7.2C30.8,9.4,30.4,9.1,30,9V5c0-2.8-2.2-5-5-5H5
			C2.2,0,0,2.2,0,5v30c0,2.8,2.2,5,5,5h20C27.8,40,30,37.8,30,35z M5,2h20c1.7,0,3,1.3,3,3v4c-0.4,0.1-0.8,0.4-1.1,0.7L16.7,19.9
			c-1.2,1.2-1.2,3.1,0,4.2l7.2,7.2c1.1,1.1,2.9,1.2,4.1,0.1V35c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3V5C2,3.3,3.3,2,5,2z M18.1,21.3
			l10.2-10.2c0.4-0.4,1-0.4,1.4,0l0.9,0.9L19,23.6l-0.9-0.9C17.7,22.3,17.7,21.7,18.1,21.3z M32,13.4l4.9,4.9c0.4,0.4,0.4,1,0,1.4
			L26.7,29.9c-0.4,0.4-1,0.4-1.4,0L20.4,25L32,13.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PosMobile
};
